import { Menu, MenuButton } from '@headlessui/react';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';
import Button, { ButtonProps } from '../Button/Button';
import NumberOfSelectedFilters from '../ManageableItemsList/components/NumberOfSelectedFilters';
import DropdownMenuItems, { TDropdownItem } from './DropdownMenuItems';

export type IProps = ButtonProps & {
  filters: TDropdownItem[];
  name?: string;
};

const FilterDropdown: FC<IProps> = (props) => {
  const { filters, name = 'Filter', ...buttonProps } = props;

  const numOfSelectedFilters = filters.filter(
    (filter) => filter.selected
  ).length;

  return (
    <Menu>
      <MenuButton as={Button} {...buttonProps}>
        <UntitledIcon name="filter-lines.3" className="h-3.5 w-3.5" />
        {name}
        {numOfSelectedFilters > 0 && (
          <NumberOfSelectedFilters
            numberOfSelectedFilters={numOfSelectedFilters}
          />
        )}
      </MenuButton>

      <DropdownMenuItems autoClose={false} hasSearch items={filters} />
    </Menu>
  );
};

export default FilterDropdown;
